import React from 'react';
import './FullScreenMessage.css'; // You'll create this CSS file to style the component

const FullScreenMessage = ({ message }) => {
    return (
        <div className="fullscreen-message">
            <p>{message}</p>
        </div>
    );
};

export default FullScreenMessage;
